import { ClientType } from '~/ApiClient';
export var ChangePriorityError;
(function (ChangePriorityError) {
})(ChangePriorityError || (ChangePriorityError = {}));
var ChangePriorityRequest = /** @class */ (function () {
    function ChangePriorityRequest(priority, notificationIds) {
        this.api = ClientType.pigeon;
        this.knownErrorCodes = Object.values(ChangePriorityError);
        this.method = 'put';
        this.body = JSON.stringify({
            notificationIds: notificationIds,
            priority: priority ? 'high' : 'normal',
        });
        this.path = "notifications/priority";
    }
    return ChangePriorityRequest;
}());
export { ChangePriorityRequest };
